import style from "../../../../assets/scss/sub/purchase/orderAndPayment.module.scss";
import {SupportButton} from "../SupportButton";
import {CouponSelector} from "../CouponSelector";
import React, {useRef} from "react";
import {Price} from "../../../../types/cart";
import {useAppSelector} from "../../../../hooks/hooks";
import {cartedProducts} from "../../../../store/cart/cartSlice";
import {useVoucherStore} from "../../../common/hooks/voucherStore";

interface Args {
    totalPrice: Price,
    selectedCouponIdx: number | null,
    resetSalesCodeDiscount: (_: void) => void,
    setSelectedCouponIdx: (_: number | null) => void,
    setCouponDiscountAmount: (_: number) => void,
}

export function CouponDiscountField(
    {
        totalPrice,
        selectedCouponIdx,
        resetSalesCodeDiscount,
        setSelectedCouponIdx,
        setCouponDiscountAmount
    }: Args) {

    const cartedProductList = useAppSelector(cartedProducts);
    const { couponCount} = useVoucherStore();
    const couponDiscountTitleRef = useRef<HTMLSpanElement>(null);

    return (
        <div className={style.supportPanel}>
            <div className={style.titleBar}>
                <h3 className={style.sectionTitle}>
                    <span ref={couponDiscountTitleRef}>쿠폰 할인</span>
                    <SupportButton
                        title={"쿠폰 이용 안내"}
                        content={[
                            "각 쿠폰은 1회 사용 가능하며, 주문 건 당 한 장만 결제 적용 가능합니다.",
                            "유효기간이 만료된 쿠폰은 사용이 불가능합니다.\n쿠폰의 유효기간을 꼭 확인해 주세요.",
                            "쿠폰을 이용하여 구매한 상품을 환불할 경우,\n이용권 구매 전 쿠폰 상태로 반환됩니다.",
                            "반환될 때의 유효기간은 최초 지급된 쿠폰의 유효 기간과 동일합니다.\n단, 환불 시점 유효기간이 경과한 쿠폰은 사용할 수 없습니다.",
                            "쿠폰과 할인 코드는 중복 적용이 불가능합니다.",
                        ]}
                        supportLeft={-(couponDiscountTitleRef.current?.getBoundingClientRect().width ?? 0)}
                    />
                </h3>
                <span className={style.couponCount}>
                    <span>보유쿠폰 </span>
                    <span className={style.count}>{couponCount}장</span>
                  </span>
            </div>
            <div className={style.selectorArea}>
                <CouponSelector
                    actualAmount={totalPrice.actualAmount}
                    products={cartedProductList ?? []}
                    changeSelectedCoupon={(couponIdx: number | null, totalDiscountAmount: number) => {
                        if (couponIdx) {
                            resetSalesCodeDiscount();
                        }
                        setSelectedCouponIdx(couponIdx);
                        setCouponDiscountAmount(totalDiscountAmount);
                    }}
                    selectedCouponIdx={selectedCouponIdx}
                />
            </div>
        </div>

    )
}